<template>
    <div id="zqzMsg">
        <top :title="title"></top>
        <div class="listBox">
            <p class="wranTop">请严格保护用户隐私，禁止任何形式的非法复制、传播和使用用户信息</p>
            <div class="setFix"></div>
            <div class="item-list" v-for="(item,i) in msgs" :key="i">
                <span class="name nowrap">{{item.username}}{{item.level=='1'?'(社区管理员)':'(执勤者)'}}</span>
                <span class="name phone2 nowrap">{{item.mobile}}</span>
                <span class="phone" v-if="isAdmin=='1'||isAdmin=='2'" @click="delItem(item.openId)">删除</span>
            </div>
        </div>
        <div class="noLists" v-show="noShow && msgs.length == 0">
            <img src="~@/assets/imgs/bg.png" alt />
            <p>暂无数据~</p>
        </div>
        <div class="setH"></div>
        <div class="btmBox">
            <mt-button type="danger" class="submitBtn" @click="intoAdd">添加新执勤者</mt-button>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import axios from 'axios'
import{ Toast,MessageBox } from 'mint-ui'
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'执勤者管理',
            noShow:false,
            msgs:[],
            isAdmin:null
        }
    },
    mounted() {
        // this.setuserToken("wr7w4pRzr4pK8a5ZC090rM8K7Jm95Acz")
        this.getLists()
    },
    methods:{
        intoAdd() {
            this.$router.push({path:`/addnew?poiId=${this.$route.query.poiId}&isAdmin=${this.isAdmin}`})
        },
        getLists() {
            axios.get(this.commonIp()+`/v1/communityManager?token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`)
            .then((res) => {
                this.isAdmin = res.data.data.isAdmin
                if(res.data.data.managers.length!=0) {
                    this.msgs = res.data.data.managers
                    this.noShow = false
                }else{
                    this.noShow = true
                }
            })
        },
        delItem(openId) {
            MessageBox({
                title: '提示',
                message: '确定删除已添加的执行者吗?',
                showCancelButton: true,
            }).then(action => {
                if (action == 'confirm') {
                    //确认的回调
                    axios.post(this.commonIp()+'/v1/communityManager/delete',{
                        token:this.getuserToken(),
                        poiId:this.$route.query.poiId,
                        openId:openId,
                    }).then((res) => {
                        if(res.data.code=='200') {
                            Toast('删除成功')
                            this.getLists()
                        }
                    })
                }
            }).catch(err => { 
                if (err == 'cancel') {     //取消的回调
                
                } 
            })
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    .mint-msgbox-confirm{
        color:#23b355;
        border-left: 1px solid #ddd;
    }
    .mint-msgbox-cancel{
        width: 50%;
        border-right: 1px solid #ddd;
    }
    #zqzMsg{
        // max-width: 750px;
        // margin:0 auto;
        .setFix{
            height:80px;
            border-bottom:1px solid #d8d8d8;
        }
        .listBox{
            .item-list{
                padding:10px 15px;
                border-bottom:1px solid #d8d8d8;
                display: flex;
                .name{
                    width:120px;
                    flex:0 0 120px;
                    &.phone2{
                        color:#999;
                    }
                }
                .phone{
                    flex:1;
                    text-align: right;
                    color:#999;
                    cursor: pointer;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/zqzmg/zqzmg.vue